import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Btn, Modal, Input, Textarea, Select, Toggle, ImageField } from "./AdminUI";
import { Plus, Edit2, Trash2, Star } from "lucide-react";

const EMPTY = { client_name: "", city: "", rating: 5, review: "", photo_url: "", service: "", project_name: "", published: true, order: 0 };

export default function TestimonialsAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/testimonials/admin/all").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!editing.client_name.trim()) return alert("Client name required");
    if (editing.id) await api.put(`/testimonials/admin/${editing.id}`, editing);
    else await api.post("/testimonials/admin", editing);
    setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete?")) { await api.delete(`/testimonials/admin/${id}`); load(); } };
  const setF = (k, v) => setEditing({ ...editing, [k]: v });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-ink">Testimonials <span className="text-muted text-base">({items.length})</span></h1>
        <Btn onClick={() => setEditing({ ...EMPTY })} data-testid="add-testimonial-btn"><Plus size={16} /> Add</Btn>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((t) => (
          <div key={t.id} className="rounded-xl2 bg-white border border-line p-5">
            <div className="flex gap-0.5 mb-2">{Array.from({ length: t.rating }).map((_, i) => <Star key={i} size={13} className="fill-gold text-gold" />)}</div>
            <p className="text-sm text-ink/80 line-clamp-3">"{t.review}"</p>
            <div className="mt-3 text-sm font-bold text-ink">{t.client_name} <span className="text-muted font-normal">· {t.city}</span></div>
            {!t.published && <span className="text-[10px] bg-ink/80 text-white px-2 py-0.5 rounded-full">Unpublished</span>}
            <div className="flex gap-2 mt-3"><Btn variant="outline" onClick={() => setEditing({ ...EMPTY, ...t })}><Edit2 size={14} /> Edit</Btn><Btn variant="danger" onClick={() => del(t.id)}><Trash2 size={14} /></Btn></div>
          </div>
        ))}
      </div>
      {editing && (
        <Modal title={editing.id ? "Edit Testimonial" : "Add Testimonial"} onClose={() => setEditing(null)}>
          <div className="space-y-4">
            <Input label="Client Name *" value={editing.client_name} onChange={(v) => setF("client_name", v)} />
            <div className="grid grid-cols-2 gap-3">
              <Input label="City / Location" value={editing.city} onChange={(v) => setF("city", v)} />
              <Input label="Project / Service" value={editing.service} onChange={(v) => setF("service", v)} placeholder="e.g. Turnkey Villa" />
            </div>
            <Input label="Project Name (optional)" value={editing.project_name} onChange={(v) => setF("project_name", v)} />
            <Select label="Rating" value={String(editing.rating)} onChange={(v) => setF("rating", parseInt(v))} options={["5", "4", "3", "2", "1"]} />
            <Textarea label="Review" value={editing.review} onChange={(v) => setF("review", v)} rows={4} />
            <ImageField label="Photo (optional)" value={editing.photo_url} onChange={(v) => setF("photo_url", v)} folder="gnons/uploads/" />
            <Toggle label="Published" checked={editing.published} onChange={(v) => setF("published", v)} />
          </div>
          <div className="flex justify-end gap-3 mt-6"><Btn variant="outline" onClick={() => setEditing(null)}>Cancel</Btn><Btn onClick={save} data-testid="save-testimonial-btn">Save</Btn></div>
        </Modal>
      )}
    </div>
  );
}
